import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackwardBtnComponent } from '@shared/components/backward-btn/backward-btn.component';
import { SvgModule } from '@shared/components/svg/svg.module';
import { RouterModule } from '@angular/router';
import { PxModule } from '@shared/pipes/px/px.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomToolTipModule } from '@shared/directives/custom-tool-tip/custom-tool-tip.module';

@NgModule({
  declarations: [BackwardBtnComponent],
  imports: [CommonModule, SvgModule, RouterModule, PxModule, MatTooltipModule, CustomToolTipModule],
  exports: [BackwardBtnComponent]
})
export class BackwardBtnModule {}
